import { BaseModel } from './BaseModel';

export default class Brand extends BaseModel {
  defaults() {
    return {
      id: '',
      name: '',
      status: 'active',
      description: '',
      health_score: '',
      phone: '',
      hours: '',
      icon_id: 0,
      icon: null,
      logo_id: 0,
      logo: null,
      brandAvailabilities: [],
    };
  }

  options() {
    return {
      identifier: 'id',
    };
  }

  // Route configuration
  routes() {
    return {
      fetch: '/brands/{id}?with=logo,icon,fulfillmentCenters.facility',
      save: '/brands/{id}',
    };
  }

  // Override onFetchSuccess
  onFetchSuccess(response) {
    const data = response.getData();

    if (!data || !data.success) {
      throw this.createResponseError('Invalid brand');
    }

    this.assign(data.data);
    this.set(this, 'fatal', false);
    this.set(this, 'loading', false);
    this.emit('fetch', {
      error: null,
    });
  }
}
